import { useQuery } from 'react-query';
import ItemServiceApi from '../../Api/item-service';
import { ItemFilters } from './enum';

export type CountVendorCatalogItems = {
  [ItemFilters.NEEDS_REVIEW]: number;
  [ItemFilters.ACCEPTED]: number;
  [ItemFilters.PENDING_VENDOR]: number;
  [ItemFilters.PO_DRAFTS]: number;
  [ItemFilters.MANAGER_REVIEW]: number;
  [ItemFilters.FINAL_REVIEW]: number;
  [ItemFilters.PO_CREATED]: number;
  [ItemFilters.REJECTED]: number;
};

export const useCountVendorCatalogItems = (userId: string) =>
  useQuery<CountVendorCatalogItems>(
    ['item-service-vendor-catalog-items-count', userId],
    () => ItemServiceApi.countVendorCatalogItems(userId),
  );
